// Преобразует URLSearchParams в объект
export const transformSearchParamsToObject = (params: URLSearchParams): Record<string, any> => {
  const obj: Record<string, any> = {};

  params.forEach((value, key) => {
    if (obj[key]) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  });

  return obj;
};
